function findAncestor(element, queryClass) {
    while ((element = element.parentElement) && !containsClass(element, queryClass));
    return element;
}

function containsClass(element, queryClass) {
    if (!element || typeof(queryClass) !== 'string') {
        return false;
    }

    return (element.className && element.className.trim().split(/\s+/g).some(x => x === queryClass)) 
}

function getListenerAction(element) {
    let action = 'click',
        tag = element.tagName.toLowerCase();

    if (tag === 'select') {
        action = 'change';
    } else if (tag === 'input' || tag === 'textarea') {
        action = 'input';
    }

    return action;
}

function getUrlParameter(queryParam) {
    let url = window.location.search.substring(1);

    if (url.indexOf(queryParam) != -1) {
        return url.split('&')
            .filter(kval => kval.indexOf(queryParam) != -1)
            .map(param => param.split("=")[1])
            .join();
    }
}

function normalize(string) {
    //normalize string from snake_case to camelCase
    if (!string.indexOf('_') > -1) {
        return string;
    }

    let strArray = string.split('_'),
        first = strArray.shift();

    return first + strArray.map(toTitleCase).join('');
}

function toTitleCase(string) {
    return string[0].toUpperCase() + string.substr(1);
}

function normalizeObj(obj) {
    return Object.keys(obj)
        .reduce((newObj, key) => {
            newObj[normalize(key)] = obj[key];
            return newObj;
        }, {});
}

function generateUID() {
    return Math.random().toString(36).substr(2, 9);
}

function renameForIdPair(root, attrName) {
    let label = root.querySelector(`[for="${attrName}"]`),
        elem = root.querySelector(`#${attrName}`),
        UID = `${attrName}-${generateUID()}`;

    label.setAttribute('for', UID);
    elem.setAttribute('id', UID);
}

export default {
    findAncestor,
    containsClass,
    getListenerAction,
    getUrlParameter,
    normalize,
    normalizeObj,
    generateUID,
    renameForIdPair,
};


// WEBPACK FOOTER //
// ./_static/js/_helpers.js